import { Button, ButtonProps } from "@/components/ui/button";
import { useStoreGroupDictionary } from "@/modules/storeGroups/hooks/useStoreGroupDictionary";
import { CirclePlus } from "lucide-react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
export default forwardRef<HTMLButtonElement, ButtonProps>(
  function AddNewStoreGroupButton(props, ref) {
    const { t } = useTranslation();
    const { ns } = useStoreGroupDictionary();
    const { can_create } = useModulePermissions();

    return (
      <Button variant="link" ref={ref} {...props} disabled={!can_create}>
        <CirclePlus className="w-5 h-5 mr-3" />
        {t(`${ns}.add`)}
      </Button>
    );
  },
);
